module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "introduction"
    }
  }, [_c('h1', [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("A short guide to the mysteries of time and the nature of existence as expressed in various media.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The author records his own views on time, space with accompanying food, art and music recommendations in a tongue in cheek fashion.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Some aspects of Einstein’s theories and later developments in astrophysics are covered with minimal use of mathematics.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The author has created illustrations to augment the text.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("****")])]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0